import styled from 'styled-components';
import { media, remCalc } from '@prisjakt/ui-base';
import ProductMediaComponent from '../product-media';
import CampaignBadgeComponent from '../../../../components/campaign-badge';
import ProductActionButtonsComponent from './components/product-actions-buttons';

const mediaImageSize = '100px';
const headerMargin = 8;

type TitleProps = {
  'data-test': string;
};

export const Title = styled.h1<TitleProps>`
  font-size: ${remCalc(22)};
  font-weight: normal;
  margin-bottom: 0px;

  ${media.smallOnly`
    font-size: ${remCalc(16)};
    margin-bottom: ${remCalc(8)}; `}
`;

export const ProductActionButtons = styled(ProductActionButtonsComponent)`
  height: auto;
`;

export const MainSection = styled.div`
  position: relative;
  display: flex;
  margin-bottom: ${remCalc(8)};
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ProductMedia = styled(ProductMediaComponent)`
  min-width: ${mediaImageSize};
  margin-right: ${remCalc(12)};
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  margin: 0 ${remCalc(headerMargin)} ${remCalc(headerMargin)};

  ${Title} {
    flex-grow: 1;
  }
`;

export const CampaignBadge = styled(CampaignBadgeComponent)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
